export const ChatHoverPresentationMode = {
  MOBILE_PEEK: "mobilePeek",
  PANEL: "panel",
  HIDDEN_EXPANDED_DESKTOP: "hiddenExpandedDesktop",
};

export const getChatHoverPresentationMode = ({
  isMobile,
  showingChatList,
  chatIsExpanded,
  screenSize,
}) => {
  if (!isMobile && chatIsExpanded && showingChatList && screenSize !== "small") {
    return ChatHoverPresentationMode.HIDDEN_EXPANDED_DESKTOP;
  }

  if (isMobile && !showingChatList) {
    return ChatHoverPresentationMode.MOBILE_PEEK;
  }

  return ChatHoverPresentationMode.PANEL;
};
